<template>
 <v-container>
 <v-card style="border-radius: 8px;">
     <v-container class="mt-0">
         <v-layout >
             <v-flex xs3>
                    <v-card-title>
                        <h2 class="font-weight-regular">Web Plugins</h2>
                    </v-card-title>
             </v-flex>             
             <v-flex xs4>
                <v-radio-group v-model="plugin">
                    <v-radio
                        label="Customer chat"
                        value="customerchat"
                    ></v-radio>
                     <v-radio
                        label="Message us"
                        value="messageus"
                    ></v-radio>
                    <v-radio
                        label="Send to Messenger"
                        value="sendtomessenger"
                    ></v-radio>
                    <v-radio
                        label="Checkbox"
                        value="checkbox"
                    ></v-radio>
                </v-radio-group>
             </v-flex>
             <v-flex xs5>
                <v-img v-if="plugin == 'customerchat'" style="border: 1px solid ; border-radius: 8px; border-color: white;"
                       src="https://storage.googleapis.com/chaty-boty.appspot.com/customerchat.png"
                       height="140"
                       width="280"
                       contain
                >
                </v-img>
                <v-img v-if="plugin == 'messageus'" style="border: 1px solid ; border-radius: 8px; border-color: white;"
                       src="https://storage.googleapis.com/chaty-boty.appspot.com/messageus.png"
                       height="120"
                       width="200"
                       contain
                >
                </v-img>
            </v-flex> 
         </v-layout> 
         <v-layout >
            <v-flex xs3>
            </v-flex> 
            <v-flex>            
                <v-card-title v-if="plugin == 'customerchat'">
                    The "customer chat" plugin allows you to integrate your Messenger experience directly into your website.
                </v-card-title>
                <v-card-title v-if="plugin == 'messageus'">
                    The "Message Us" plugin can be used to immediately start a conversation and send the person to Messenger.
                </v-card-title>
                <v-card-title v-if="plugin == 'sendtomessenger'">
                    The "Send to Messenger" plugin allows users to opt-in to receive messages from your bot in Messenger.
                </v-card-title>
                <v-card-title v-if="plugin == 'checkbox'">
                    The "Checkbox" plugin allows users to opt-in to receive messages from your bot in Messenger. Specially used for the forms.
                </v-card-title>
            </v-flex>
         </v-layout>
         <v-layout v-if="plugin == 'customerchat'">
             <v-flex xs3>
                <v-card-title>
                        <h2 class="font-weight-regular">Greetings</h2>
                </v-card-title>
             </v-flex>
             <v-flex>
                 <v-layout>                     
                    <v-flex xs6>
                        <v-text-field
                            label="Greeting if logged in"
                            placeholder="Optional" 
                            v-model="logged_in_greeting"
                            counter="80"              
                        ></v-text-field>
                    </v-flex>                    
                    <v-flex xs6>
                        <v-text-field
                            label="Greeting if logged out"
                            placeholder="Optional" 
                            v-model="logged_out_greeting" 
                            counter="80"            
                        ></v-text-field>
                    </v-flex>
                 </v-layout>
                 <v-layout>
                    <v-flex xs6>
                    </v-flex>
                 </v-layout>
             </v-flex>
         </v-layout>
        <v-layout v-if="plugin == 'customerchat'">
             <v-flex xs4>
                <v-card-title>
                        <h2 class="font-weight-regular">Theme color</h2>
                </v-card-title>
             </v-flex>
             <v-flex xs6>
             <v-text-field
                label="Color code in Hex" 
                v-model="theme_color"             
            ></v-text-field>
             </v-flex>
             <v-flex xs1>
                <v-icon class="mt-4"
                :color="theme_color" right>fiber_manual_record</v-icon>
             </v-flex>
             <v-flex xs5>
                <v-btn class="mt-3" flat round color="primary" href="https://www.google.com/search?q=color+picker" target="_blank">
                    Check the color codes
                    <v-icon small right dark>open_in_new</v-icon>
                </v-btn>
             </v-flex>
         </v-layout>
        <v-layout v-if="plugin == 'checkbox'">
             <v-flex xs4>
                <v-card-title>
                        <h2 class="font-weight-regular">Origin</h2>
                </v-card-title>
             </v-flex>
             <v-flex xs6>
             <v-text-field
                label="Web origin"
                placeholder="optional" 
                v-model="origin"             
            ></v-text-field>
             </v-flex>
             <v-flex xs6>
             </v-flex>
         </v-layout>
         <v-layout v-if="plugin == 'sendtomessenger'">
             <v-flex xs4>
                <v-card-title>
                        <h2 class="font-weight-regular">Button name</h2>
                </v-card-title>
             </v-flex>
             <v-flex xs6>
             <v-select
                item-text="name"
                item-value="value"
                label="Button name"
                :items="buttonnames" 
                placeholder="Optional"
                v-model="buttonname"             
            ></v-select>
             </v-flex>
             <v-flex xs6>
             </v-flex>
         </v-layout>
         <v-layout v-if="plugin == 'customerchat' || plugin == 'sendtomessenger' || plugin == 'checkbox'">
             <v-flex xs4>
                <v-card-title>
                        <h2 class="font-weight-regular">Ref parameter</h2>
                </v-card-title>
             </v-flex>
             <v-flex xs6>
             <v-text-field
                label="Ref parameter"
                placeholder="optional" 
                v-model="ref"             
            ></v-text-field>
             </v-flex>
             <v-flex xs6>
             </v-flex>
         </v-layout>

        <v-layout v-if="plugin == 'messageus' || plugin == 'sendtomessenger' || plugin == 'checkbox'">            
            <v-flex xs3>
                <v-card-title>
                        <h2 v-if="plugin != 'checkbox'" class="font-weight-regular">Color</h2>
                        <h2 v-if="plugin == 'checkbox'" class="font-weight-regular">Skin</h2>
                </v-card-title>
            </v-flex>
            <v-flex xs6>
                <v-radio-group v-if="plugin != 'checkbox'" v-model="color">
                    <v-radio
                        label="Blue"
                        value="blue"
                    ></v-radio>
                     <v-radio
                        label="White"
                        value="white"
                    ></v-radio>
                </v-radio-group>
                <v-radio-group v-if="plugin == 'checkbox'" v-model="skin">
                    <v-radio
                        label="Light"
                        value="light"
                    ></v-radio>
                    <v-radio
                        label="Dark"
                        value="dark"
                    ></v-radio>
                </v-radio-group>
            </v-flex>
        </v-layout>

        <v-layout  v-if="plugin == 'messageus' || plugin == 'sendtomessenger' || plugin == 'checkbox'">            
            <v-flex xs3>
                <v-card-title>
                        <h2 class="font-weight-regular">Size</h2>
                </v-card-title>
            </v-flex>
            <v-flex xs6>
                <v-radio-group v-model="size">
                    <v-radio
                        v-if="plugin == 'checkbox'"
                        label="Small"
                        value="small"
                    ></v-radio>
                    <v-radio
                        v-if="plugin == 'checkbox'"
                        label="Medium"
                        value="medium"
                    ></v-radio>
                    <v-radio
                        label="Standard"
                        value="standard"
                    ></v-radio>
                     <v-radio
                        label="Large"
                        value="large"
                    ></v-radio>
                    <v-radio
                        label="Extra large"
                        value="xlarge"
                    ></v-radio>
                </v-radio-group>
            </v-flex>
        </v-layout>


         <v-layout  v-if="plugin == 'customerchat' || plugin == 'checkbox' || plugin == 'sendtomessenger'">
             <v-flex xs3>
             </v-flex>
             <v-flex>
                     <v-btn flat round color="primary" :to="'/settings/dw/'+pageid" target="_blank">
                         Check domain whitelisitng
                         <v-icon small right dark>open_in_new</v-icon>
                    </v-btn>
             </v-flex>
         </v-layout> 
         <v-layout >
             <v-flex xs3>
             </v-flex>
             <v-flex>
                <v-btn @click.stop="dialog = true" flat round color="primary">Get code</v-btn>
             </v-flex>
         </v-layout> 
    </v-container>           
 </v-card>
 <v-dialog
    v-model="dialog"
    max-width="800"
 >
    <v-card>
        <v-container>
            <v-layout>                
                <v-card-title>
                        <h2 class="font-weight-regular">Copy below code and place it in your website</h2>
                </v-card-title>
                <v-btn class="mt-3 ml-5" @click="copyCode" flat round color="primary">
                    <v-icon small left dark>file_copy</v-icon>
                    Copy code                    
                </v-btn>
            </v-layout>
            <v-textarea
                rows="20"
                id="codetocopy"
                box
                :value="ccode"
                readonly
            >
            </v-textarea>
        </v-container>
    </v-card>
 </v-dialog>
</v-container>    
</template>

<script>
import {customerchat,messageus,sendtomessenger,checkbox} from '@/plugins/fbsdkvars.js'; 
import {app_id} from '@/plugins/projectvars.js'; 
export default {
    data(){
        return{
            plugin:'customerchat',
            logged_in_greeting:"Hi! How can we help you?",
            logged_out_greeting:"Hi! How can we help you?",
            greeting_dialog_delay:null,
            greeting_dialog_display:null,
            theme_color:'#0084ff',
            display:["show","hide","fade"],
            dialog:false,
            color:"blue",
            size:"standard",
            skin:"light",
            ref:null,
            origin:null,
            buttonname:"",
            buttonnames:[
                {"name":"Send to Messenger","value":""},                
                {"name":"Get this in messenger","value":"GET_THIS_IN_MESSENGER"},
                {"name":"Receive this in messenger","value":"RECEIVE_THIS_IN_MESSENGER"},
                {"name":"Send this to me","value":"SEND_THIS_TO_ME"},
                {"name":"Get customer assistance","value":"GET_CUSTOMER_ASSISTANCE"},
                {"name":"Get customer service","value":"GET_CUSTOMER_SERVICE"},
                {"name":"Get support","value":"GET_SUPPORT"},
                {"name":"Let us chat","value":"LET_US_CHAT"},
                {"name":"Send me messages","value":"SEND_ME_MESSAGES"},
                {"name":"Alert me in messenger","value":"ALERT_ME_IN_MESSENGER"},
                {"name":"Send me updates","value":"SEND_ME_UPDATES"},
                {"name":"Message me","value":"MESSAGE_ME"},
                {"name":"Let me know","value":"LET_ME_KNOW"},
                {"name":"Keep me updated","value":"KEEP_ME_UPDATED"},
                {"name":"Tell me more","value":"TELL_ME_MORE"},
                {"name":"Subscribe in messenger","value":"SUBSCRIBE_IN_MESSENGER"},
                {"name":"Subscribe ro updates","value":"SUBSCRIBE_TO_UPDATES"},
                {"name":"Get messages","value":"GET_MESSAGES"},
                {"name":"Subscribe","value":"SUBSCRIBE"},
                {"name":"Get started in messenger","value":"GET_STARTED_IN_MESSENGER"},
                {"name":"Learn more in messenger","value":"LEARN_MORE_IN_MESSENGER"},
                {"name":"Get started","value":"GET_STARTED"}
            ]
        }
    },
    computed:{
        ccode(){
            let pageid = this.$route.params.page_id
            if(this.plugin == 'customerchat'){
            let div = '\n'+"<div class=\"fb-customerchat\""+
                        '\n'+"theme_color=\""+this.theme_color+"\""+
                        '\n'+"logged_in_greeting=\""+this.logged_in_greeting+"\""+
                        '\n'+"logged_out_greeting=\""+this.logged_out_greeting+"\""+
                        '\n'+"ref=\""+this.ref+"\""+
                        '\n'+"page_id=\""+pageid+"\">"+
                        '\n'+"</div>"
            return customerchat+'\n'+div   
            } 
            else if(this.plugin == 'messageus') {
                let div = '\n'+"<div class=\"fb-messengermessageus\""+
                        '\n'+"messenger_app_id=\""+app_id+"\""+
                        '\n'+"page_id=\""+pageid+"\""+
                        '\n'+"color=\""+this.color+"\""+
                        '\n'+"size=\""+this.size+"\">"+
                        '\n'+"</div>"
            return messageus+'\n'+div 
            }
            else if(this.plugin == 'sendtomessenger') {
                let div = '\n'+"<div class=\"fb-send-to-messenger\""+
                        '\n'+"messenger_app_id=\""+app_id+"\""+
                        '\n'+"page_id=\""+pageid+"\""+
                        '\n'+"data-ref=\""+this.ref+"\""+
                        '\n'+"cta_text=\""+this.buttonname+"\""+
                        '\n'+"color=\""+this.color+"\""+
                        '\n'+"size=\""+this.size+"\">"+
                        '\n'+"</div>"
            return sendtomessenger+'\n'+div 
            }
            else if(this.plugin == 'checkbox') {
                let div = '\n'+"<div class=\"fb-messenger-checkbox\""+
                        '\n'+"messenger_app_id=\""+app_id+"\""+
                        '\n'+"page_id=\""+pageid+"\""+
                        '\n'+"origin=\""+this.origin+"\""+                        
                        '\n'+"user_ref=\"\""+
                        //'\n'+"user_ref=\""+this.ref+"\""+
                        '\n'+"allow_login=\"true\""+
                        '\n'+"skin=\""+this.skin+"\""+
                        '\n'+"size=\""+this.size+"\""+
                        '\n'+"center_align=\"true\">"+
                        '\n'+"</div>"
            return checkbox+'\n'+div 
            }       
        },
        pageid(){
            return this.$route.params.page_id
        }
        
    },
    methods:{
        copyCode(){
            let copyText = document.querySelector("#codetocopy");
            copyText.select();
            document.execCommand("copy");
        }
    }
}
</script>
